const C_TO_F_SCALE = 9 / 5;
const F_TO_C_SCALE = 5 / 9;

export const degreesToUserPreference = (temp, userPreference, delta = false) => {
    if (userPreference === "celsius") {
        return temp;
    } else if (userPreference === "fahrenheit") {
        return delta ? celsiusDeltatoFahrenheit(temp) : celsiusToFarenheit(temp);
    }

    return temp;
};

export const getTempUnit = (userPreference) => {
    if (userPreference === "celsius") {
        return "ºC";
    } else if (userPreference === "fahrenheit") {
        return "ºF";
    }

    return "ºC";
};

const celsiusToFarenheit = (celsius, round = true) => {
    let farenheit = celsius * 1.8 + 32;

    if (round) {
        return Math.round(farenheit);
    }
    return farenheit;
};

export const farenheitToCelsius = (farenheit, round = true) => {
    const celsius = (farenheit - 32) / (9 / 5);

    if (round) {
        return Math.round(celsius);
    }
    return celsius;
};

export const celsiusDeltatoFahrenheit = (c, round = true) => {
    const f = c * C_TO_F_SCALE;
    return round ? Math.round(f) : f;
};

export const fahrenheitDeltaToCelsius = (f, round = true) => {
    const c = f * F_TO_C_SCALE;
    return round ? Math.round(c) : c;
};
